import styled from 'styled-components';

export const CardItemContainer = styled.div<{ height: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: ${props => props.height}rem;
  background-color: ${props => props.theme.colors.white};
  padding: ${props => `${props.theme.space.none} ${props.theme.space['2.8']} ${props.theme.space.none}`};
  ${props => props.theme.mediaQueries.small} {
    padding: ${props => `${props.theme.space.none} ${props.theme.space['5.0']}`};
  }
`;
